import React, { useContext, useEffect, useRef } from "react";
import { WebSocketContext } from "../../contexts/WebSocketContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "./ToastProvider";
import { getUserType } from "../../utils/authutils";
import { useCreateNotification } from "../notification/notificationQuery";
import { useQueryClient } from "@tanstack/react-query";
export function ShowNotification() {
  const { pathname } = useLocation();
  const { chatMessages = [] } = useContext(WebSocketContext);
  const { addToast } = useToast();
  const navigate = useNavigate();
  const user = getUserType();
  const { mutate, isSuccess } = useCreateNotification();
  const firstRun = useRef(true);
  const qc = useQueryClient();
  const allowedUsers = ["contractor_admin", "contractor_owner", "contractor_manager", "client"];
  const handleDynamicRouting = (tenderId) => {
    let finalPath = "/dashboard"; // default fallback

    switch (user) {
      case "contractor_admin":
      case "contractor_owner":
      case "contractor_manager":
        finalPath = `/dashboard/contractor/ongoing/tasks/${tenderId}?tab=Communication`;
        break;

      case "client":
        finalPath = `/dashboard/ongoing-tender-details/${tenderId}?tab=Communication`;
        break;

      default:
        finalPath = "/dashboard";
    }

    // ✅ Single check for all cases
    if (pathname !== finalPath) {
      navigate(finalPath);
    }
  };
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }

    let lastMessage = null;
    let paths;
    if (chatMessages.length > 0) {
      lastMessage = chatMessages[chatMessages.length - 1];
      paths = generateDynamicPaths(lastMessage?.tender_id || "");
      if (
        lastMessage &&
        lastMessage.sender_type !== user &&
        !paths.includes(pathname) &&
        allowedUsers.includes(user)
      ) {
        mutate(lastMessage);
        addToast(
          {
            message: lastMessage?.tender_name || "New Notification",
            description: lastMessage?.message.slice(0, 40) || "",
            type: "info",
          },
          "info",
          2000,
          {
            position: "bottom-right",
            onClick: () => {
              handleDynamicRouting(lastMessage?.tender_id);
            },
          },
        );
      }
    }
  }, [chatMessages.length]);
  useEffect(() => {
    if (isSuccess) {
      qc.invalidateQueries({ queryKey: ["notifications"] });
    }
  }, [isSuccess]);
  return null;
}

function generateDynamicPaths(tenderId) {
  const paths = [];
  paths.push(`/dashboard/contractor/ongoing/tasks/${tenderId}`);
  paths.push(`/dashboard/ongoing-tender-details/${tenderId}`);
  return paths;
}
